var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNote = function SvgNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M14.667 8.833V3A1.667 1.667 0 0 0 13 1.333H3A1.667 1.667 0 0 0 1.333 3v10A1.667 1.667 0 0 0 3 14.667h5.833m5.834-5.834H10.5A1.667 1.667 0 0 0 8.833 10.5v4.167m5.834-5.834v.144c0 .442-.176.865-.489 1.178l-4.023 4.023a1.67 1.67 0 0 1-1.178.489h-.144"
  })));
};
export default SvgNote;